import * as React from "react";
import { Label } from "../Label";
import { Textarea } from "../Textarea";
import { cn } from "../../utils";

// Re-export so all three form-field primitives come from one place.
export { FormInput } from "../Input";
export type { FormInputProps } from "../Input";
export { FormSelect } from "../Select";

// ============================================================
// FormTextarea
// ============================================================

export interface FormTextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
    label?: string;
    error?: string;
    required?: boolean;
}

export const FormTextarea = React.forwardRef<HTMLTextAreaElement, FormTextareaProps>(
    ({ label, error, required, id, className, ...props }, ref) => (
        <div className="grid gap-1.5">
            {label && (
                <Label htmlFor={id}>
                    {label}
                    {required && <span className="text-red-500 ml-0.5">*</span>}
                </Label>
            )}
            <Textarea
                id={id}
                ref={ref}
                aria-describedby={error && id ? `${id}-error` : undefined}
                className={cn(error && "border-red-500", className)}
                {...props}
            />
            {error && <p id={id ? `${id}-error` : undefined} className="text-sm text-red-500">{error}</p>}
        </div>
    ),
);
FormTextarea.displayName = "FormTextarea";
